import * as React from 'react';
import { Field, reduxForm, change, FieldArray, arrayRemove, arrayInsert } from 'redux-form';
//import DEform from '../forms/DEform';

//import saveSettings from '../container/SettingsContainer/saveSettings';

import { TouchableOpacity, FlatList, ScrollView, LayoutAnimation } from 'react-native';
import { ListItem, List, H2, CardItem, Container, Header, InputGroup, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, Card } from 'native-base';

//import * as _ from 'lodash';
import Picker from '../components/picker';

import customValidate from './validators';
import { textInput, moneyInput, renderPicker, renderDateField, renderCheckbox, percentInput, displayInput, renderSwitch } from './renderedComponents';

const labelWidth = 120;

const syncValidate = values => {
	let errors = {};

	//errors.something = "OOh"

	return errors;
};
const mustBePresent = value => (value ? undefined : 'Required');

function asyncValidate(values, dispatch, props, field) {
	return new Promise((resolve, reject) => {
		//on blur budget
		var value = Number(values[field]);
		var Dispval = parseFloat(isNaN(value) ? 0 : value).toFixed(2);
		__DEV__ && console.log('changing ', field, Dispval);
		dispatch(change('BusDetails.ExpenseType', field, Dispval));

		resolve();
	});
}

class ExpenseTypeForm extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = { editingItem: null };
		this.state = this.initialState;
	}

	_changeFormVal(field, val) {
		__DEV__ && console.log('setting ', field, val);
		this.props.dispatch(change('BusDetails.ExpenseType', field, val));
	}

	render() {
		const { handleSubmit, pristine, reset, submitting, hmrcCats, calStart, firstYearStart } = this.props;
		//console.log(hmrcCats);
		//gets given props.handleSubmit. Need to call handleSubmit(submitFn)
		//this.ds = new ListView.DataSource({ rowHasChanged: (r1, r2) => r1 !== r2 });
		//console.log(this.props);

		//label floating, inline, stacked
		return (
			<Content keyboardShouldPersistTaps={'handled'} style={{ flex: 1 }}>
				<Form onSubmit={this.props.handleSubmit}>
					<View padder>
						<Field name="categoryName" labelWidth={108} label="Name" component={textInput} validate={mustBePresent} />
						<Field name="description" labelWidth={108} label="Description" placeholder="Your Description" component={textInput} />
						<Field name="hmrcCat" labelWidth={80} labelType="floating" label="Tax Type" component={renderPicker} iosHeader="Select type" mode="dropdown" validate={mustBePresent}>
							{hmrcCats.map((item, i) => (
								<Picker.Item key={i} label={item.name} value={item.id} />
							))}
						</Field>
						{calStart != firstYearStart && <Field name={`openingBalance`} labelWidth="50%" label={'Opening balance to ' + calStart} component={moneyInput} />}
						<Field name="budget" labelWidth="50%" label={`Budget (per month)`} component={moneyInput} />
						<Field name="outOfVatScope" label="Out of scope for VAT" component={renderSwitch} />
					</View>
				</Form>
			</Content>
		);
	}
}

export default reduxForm({
	form: 'BusDetails.ExpenseType',
	validate: syncValidate,
	asyncValidate,
	asyncBlurFields: ['budget']
})(ExpenseTypeForm);
